/* @flow */

//----------------------------------------------------------------------//
// GLOBAL IMPORTS
//----------------------------------------------------------------------//

import * as React from 'react';
import { observable } from 'mobx';
import { observer } from 'mobx-react';

//----------------------------------------------------------------------//
// LOCAL IMPORTS
//----------------------------------------------------------------------//

import ElectroNumberField from 'forms/components/inputs/ElectroNumberField/ElectroNumberField';
import ElectroSelectExtra from 'forms/components/inputs/ElectroSelectExtra/ElectroSelectExtra';
import ElectroTextField from 'forms/components/inputs/ElectroTextField/ElectroTextField';
import AutoCompleteModel from 'models/forms/AutoCompleteModel.js';

import getCurrencySymbol from 'utils/getCurrencySymbol';

import { autoCompleteManufacturers, autoCompleteProducts } from 'api/forms.js';

//----------------------------------------------------------------------//
// REACT COMPONENT
//----------------------------------------------------------------------//

type TypeProps = {|
  form: Object,
  itemData: Object,
  setMode: Function,
  inEditMode: boolean,
|};

@observer
export default class ProductAdditionRequest extends React.Component<*> {
  @observable manufacturerModel: AutoCompleteModel = new AutoCompleteModel(
    autoCompleteManufacturers
  );

  @observable modelProduct: AutoCompleteModel = new AutoCompleteModel(autoCompleteProducts);

  render(): React.Element<*> {
    const { form, itemData, setMode, inEditMode }: TypeProps = this.props;

    const activeUser: Object = JSON.parse(localStorage.getItem('user'));

    return (
      <div>
        <ElectroSelectExtra
          isFlex={true}
          field={form.$('productAddition.manufacturer_name')}
          form={form}
          formName="productAddition"
          labelKey="name"
          valueKey="id"
          extraFilters={['aliases']}
          disabled={!inEditMode}
          onSetEdit={() => {
            setMode(true);
          }}
          onResetFunc={() => {
            setMode(false);
          }}
          props={{
            model: this.manufacturerModel,
            modelChild: this.modelProduct,
            itemData: itemData.fields,
          }}
        />
        <ElectroSelectExtra
          isFlex={true}
          field={form.$('productAddition.model')}
          form={form}
          formName="productAddition"
          labelKey="model"
          valueKey="model"
          disabled={!inEditMode}
          onSetEdit={() => {
            setMode(true);
            form.$('productAddition.inEditMode').value = true;
          }}
          onResetFunc={() => {
            setMode(false);
            form.$('productAddition.inEditMode').value = false;
          }}
          props={{
            model: this.modelProduct,
            itemData: itemData.fields,
          }}
        />
        <ElectroTextField field={form.$('productAddition.base_model')} disabled={inEditMode} />
        <ElectroTextField
          field={form.$('productAddition.product_group_description')}
          disabled={inEditMode}
          props={{
            multiline: true,
            rows: 4,
          }}
        />
        <ElectroNumberField
          field={form.$('productAddition.fair_market_value')}
          prefix={getCurrencySymbol(null, activeUser.currency)}
          disabled={inEditMode}
        />
      </div>
    );
  }
}
